import lodash from 'lodash'
import React, { useMemo, useState } from 'react'
import { ButtonGroup, Col, Row } from 'react-bootstrap'

import Button from '../../../../../../1stlog-ui/src/components/Button'
// import ButtonBlock from '../../../../../../1stlog-ui/src/components/ButtonBlock'
import Dialog from '../../../../../../1stlog-ui/src/components/Dialog'
// import Bar from './Bar'
import NewScanner from './NewScanner'
// import Qr from './Qr'

type TScannerProps = { onScanned: (code: string) => void }

const Scanner = (props: TScannerProps): React.ReactElement => {
  const { onScanned } = props

  const [isOpen, setIsOpen] = useState(false)
  const [mode, setMode] = useState('qr')

  const open = (): void => setIsOpen(true)

  const close = (): void => setIsOpen(false)

  const onScan = (code: string): void => {
    close()
    onScanned(code)
  }

  const component = useMemo(() => {
    return <NewScanner onScan={onScan} />
    // switch (mode) {
    //   case 'qr':
    //     return <Qr onScan={onScan} />
    //   case 'bar':
    //     return <Bar onScan={onScan} />
    //   default:
    //     return null
    // }
  }, [mode])

  return (
    <>
      <Button icon="fas fa-qrcode" onClick={open}>
        {i18n.t('scan', 'Scannen')}
      </Button>
      <Dialog
        isOpen={isOpen}
        onClose={close}
        title={i18n.t('scan', 'Scannen')}
        closeButton={i18n.t('close', 'Schliessen')}
      >
        {/* <ButtonBlock
          value={mode}
          onChange={setMode}
          options={[
            {
              value: 'qr',
              label: i18n.t('qr_code', 'QR-Code'),
            },
            {
              value: 'bar',
              label: i18n.t('barcode', 'Barcode'),
            },
          ]}
        /> */}
        {isOpen && <div className="mt-0">{component}</div>}
      </Dialog>
    </>
  )
}

export default Scanner
